import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';

import { Angulartics2RouterlessModule } from 'angulartics2';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { catchError, of, take, tap, timeout } from 'rxjs';

import { ServerDate } from '@tablesready/server-time';
import {
  ConnectionAlertModule,
  LoaderModule,
  UtilsModule,
  GlobalErrorHandler,
  ServerTimeService,
} from '@tablesready/common-ui';
import { PROVIDERS } from './providers';
import { AppRouterModule } from './app-router.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { ApiClientModule, ApiClientService } from '@tablesready/api-client';
import {
  AppVariablesModule,
  appVariablesProvider,
  AppVariablesService,
} from '@tablesready/frontend-variables';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { IonicModule } from '@ionic/angular';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { ErrorInterceptor } from '@tablesready/common-ui';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FrontendKeyboardModule } from '@tablesready/frontend-keyboard';

const SERVER_TIME_BOOTSTRAP_TIMEOUT_MS = 10000;

@NgModule({
  imports: [
    ApiClientModule,
    BrowserModule,
    AlertsModule,
    ConnectionAlertModule,
    LoaderModule,
    AppRouterModule,
    FrontendModalModule,
    AppVariablesModule,
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
    AngularSvgIconModule.forRoot(),
    UtilsModule,
    FrontendIconsModule,
    Angulartics2RouterlessModule.forRoot(),
    AlertsModule.forRoot(),
    FrontendKeyboardModule,
  ],
  providers: [
    appVariablesProvider,
    AppVariablesService,
    ApiClientService,
    {
      provide: 'LOG_ERRORS',
      useValue: environment.logErrors,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appVariablesService: AppVariablesService) => {
        return () => appVariablesService.getAppVariables().toPromise();
      },
      multi: true,
      deps: [AppVariablesService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (serverTimeService: ServerTimeService) => {
        return () => {
          return serverTimeService.offset$
            .pipe(
              tap(offset => {
                ServerDate.setOffset(offset)
              }),
              take(1),
              // The shared offset stream skips failed samples and keeps polling.
              // Let public pages boot even if no successful sample arrives.
              timeout({ first: SERVER_TIME_BOOTSTRAP_TIMEOUT_MS }),
              catchError(() => of(null)),
            )
        };
      },
      multi: true,
      deps: [ServerTimeService],
    },
    ...PROVIDERS,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule { }
